import {
  Injectable
} from '@angular/core';

import {
  UserContext
} from '../user-context';

import {
  NavigationEnd,
  Router, RouterEvent
} from '@angular/router';

import {AuthService} from '../auth/auth.service';
import {webSocket, WebSocketSubject} from 'rxjs/webSocket';
import {BehaviorSubject, interval, Observable, Subject, timer} from 'rxjs';
import {NavigationEvent} from '@progress/kendo-angular-dropdowns/dist/es2015/navigation.service';

export interface AuthorizeMessage {
  authorize: string
}

//export interface APIMessage {

//}

@Injectable()
export class MDLinkService {

  private static socketStatus: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public connectionSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public mdLinkSocket: WebSocketSubject<any>;
  private shouldReconnectToSocket = false;
  private linkObserver:any;
  private reconnectTimer:Subject<any>;
  private noOpObserver:any;
  private noOpObservable = timer(120000,120000);
  private url = 'wss://nj94m65ygb.execute-api.us-east-1.amazonaws.com/v1';//wss://socket.mdlink.ca';//wss://sessionserver-env.us-east-1.elasticbeanstalk.com';

  send = (message:any) => {
    this.mdLinkSocket.next(message);
  };

  constructor(
              private auth: AuthService,
              private userContext: UserContext,
              private router: Router) {

    MDLinkService.socketStatus.subscribe( status => {
      this.connectionSubject.next(status);
      if(status) {
        console.log("Starting noop schedule");
        this.noOpObserver = this.noOpObservable.subscribe(n => this.send({action:"noop"}));
      } else if(this.noOpObserver) {
        console.log("Terminating noop schedule");
        this.noOpObserver.unsubscribe();
      }
      this.shouldReconnectToSocket = true;
    });

    this.router.events.subscribe((event: RouterEvent) => {
      if (event instanceof NavigationEnd) {
        //console.log("Navigating to " + event.urlAfterRedirects);
        if( !event.urlAfterRedirects.includes("telehealth") && !event.urlAfterRedirects.includes("live") && !event.urlAfterRedirects.includes("deferred") ) {
          this.shouldReconnectToSocket = false;
          this.mdLinkSocket.unsubscribe();
        }
      }
    });
  }

  public connect(): void {
    if( !MDLinkService.socketStatus.value ) {
      console.log("** Attempting to connect mdlink socket");
      this.mdLinkSocket = webSocket({
          url: `${this.url}?token=${this.auth.getToken()}`,
          closeObserver: {
            next(closeEvent) {
              MDLinkService.socketStatus.next(false);
              console.log('mdlink socket disconnected ' + MDLinkService.socketStatus.value);
              if( this.shouldReconnectToSocket ) {
                this.reconnectTimer = interval(5000).subscribe(x => {
                  console.log("Trying to reconnect to socket")
                  this.connect();
                });
              }
            }
          },
          openObserver: {
            next: () => {
              MDLinkService.socketStatus.next(true);
              if( this.reconnectTimer )
                this.reconnectTimer.unsubscribe();
              console.log('mdlink socket connected ' + MDLinkService.socketStatus.value);
            }
          },
        }
      );
      this.linkObserver = this.mdLinkSocket.subscribe(
        msg => console.log('message received: ' + JSON.stringify(msg,null,4)),
        err => console.log("web socket error: " + err),
        () => {
          console.log('web socket closed');
        }
      );

    } else {
      console.log("** mdlink socket already connected");
    }
  }

  public register(): void {
    this.send({action:"register"});
  }

  public startAppointment(appointment:string): void {
    this.send({action:"appointment", appointment:appointment});
  }

  public reset(register:boolean): void {
    this.send({action:"reset", register:register});
  }

}
